import classNames from 'classnames'
import React from 'react'

interface CardProps {
  variants?: CardVariant[]
  className?: string
  style?: React.CSSProperties
}

type CardVariant =
  | 'loading'
  | 'floating'
  | 'roomy'
  | 'squashy'
  | 'ghost'
  | 'secondary'
  | 'tertiary'
  | 'outlined'

export const Card: React.FC<CardProps> = ({
  variants = [],
  className = '',
  style = {},
  children,
}) => {
  const variantClasses = variants.map((variant) => `stk-card--${variant}`)
  return (
    <div
      className={classNames('stk-card', ...variantClasses, className)}
      style={{ ...style }}
    >
      {children}
    </div>
  )
}

interface CardsProps {
  variants?: CardsVariant[]
  className?: string
}

type CardsVariant = 'loading' | 'floating' | 'outlined'

export const Cards: React.FC<CardsProps> = ({
  variants = [],
  className = '',
  children,
}) => {
  const variantClasses = variants.map((variant) => `stk-cards--${variant}`)

  return (
    <div className={classNames('stk-cards', ...variantClasses, className)}>
      {children}
    </div>
  )
}
